import React from "react";

function Footer() {
  return (
    <footer className="mt-5 py-4 bg-dark text-light">
      <div className="container text-center">
        <p className="mb-0">
          Conteúdo meramente informativo, sem garantia de funcionamento para
          todos os modelos. Faça por sua conta e risco.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
